// import {
//   AbstractControl,
//   AsyncValidatorFn,
//   ValidationErrors,
// } from '@angular/forms';

// import { AuthHttpService } from '@ib-core/services/auth-http.service';
// import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
// import { BehaviorSubject, Observable, of } from 'rxjs';
// import { map } from 'rxjs/operators';

// export class IsPhoneAvailableAsyncValidator {
//   static createValidator(
//     authHttp: AuthHttpService,
//     error: FORM_ERRORS,
//     loading$: BehaviorSubject<boolean>,
//   ): AsyncValidatorFn {
//     return (control: AbstractControl): Observable<ValidationErrors> => {
//       const keys = Object.keys(control.errors || {});
//       const isValidNumber =
//         keys.length === 0 || (keys.length === 1 && keys[0] === error);
//       if (isValidNumber) {
//         if (control.value) {
//           loading$.next(true);
//           return authHttp.checkIsPhoneAvailable(control.value).pipe(
//             map(res => {
//               const err = res.isPhoneAvailable ? null : { [error]: true };
//               authHttp
//                 .checkSecureCode({
//                   phone: control.value,
//                   phoneCountry: 'NA',
//                   code: '123456',
//                 })
//                 .subscribe({
//                   next: res => {
//                     console.log('check secure code response: ', res);
//                   },
//                 });
//               if (err) {
//                 control.markAsTouched();
//                 control.markAsDirty();
//               }
//               loading$.next(false);
//               return err;
//             }),
//           );
//         } else {
//           return of(null);
//         }
//       } else {
//         return of(null);
//       }
//     };
//   }
// }
import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { AuthHttpService } from '@ib-core/services/auth-http.service';
import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export class IsPhoneAvailableAsyncValidator {
  static createValidator(
    authHttp: AuthHttpService,
    error: FORM_ERRORS,
    loading$: BehaviorSubject<boolean>,
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      const keys = Object.keys(control.errors || {});
      const isValidNumber =
        keys.length === 0 || (keys.length === 1 && keys[0] === error);
      if (isValidNumber) {
        if (control.value) {
          loading$.next(true);
          return authHttp.checkIsPhoneAvailable(control.value).pipe(
            map(res => {
              const err = res.isPhoneAvailable ? null : { [error]: true };
              if (err) {
                control.markAsTouched();
                control.markAsDirty();
              }
              loading$.next(false);
              return err;
            }),
          );
        } else {
          return of(null);
        }
      } else {
        return of(null);
      }
    };
  }
}
